import React from "react";
import { connect } from "react-redux";
import { createArticle } from "../../actions/catadvs";
import { USER_ROLES } from "../../utils/constant";
import { getRole, capitalize } from "../../utils/tools";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Button,
  FormGroup,
  UncontrolledAlert,
  Modal
} from "reactstrap";
import ReactBSAlert from "react-bootstrap-sweetalert";
import ReactCrop from "react-image-crop";
import TextEditor from "../../components/Commons/TextEditor";
import ArticleForm from "../../components/catadvs/AdvForm";
import OverlayLoading from "../../components/Commons/OverlayLoading.jsx";
import moment from "moment";
import { DOMAIN } from "../../utils/constant";
import { Elements, StripeProvider } from "react-stripe-elements";
import { CardElement, injectStripe } from "react-stripe-elements";
import qs from "query-string";
class AricleNewPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      article: {
        category_ids: [96],
        type: "right",
        vacancy_weeks: 1
      },
      crop: {
        unit: "%",
        width: 30,
        aspect: 16 / 10
      },
      src: null,
      croppedImageUrl: null,
      editable: false,
      paymentModal: false
    };
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.onContentChange = this.onContentChange.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.onImageLoaded = this.onImageLoaded.bind(this);
    this.onCropComplete = this.onCropComplete.bind(this);
    this.onCropChange = this.onCropChange.bind(this);
    this.onSelectFile = this.onSelectFile.bind(this);

    this.makeClientCrop = this.makeClientCrop.bind(this);
    this.getCroppedImg = this.getCroppedImg.bind(this);
    this.confirmImg = this.confirmImg.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.submitArticle = this.submitArticle.bind(this);
  }

  onTextInputChange(e, target) {
    let value = e.target.value;
    let article = this.state.article;
    article[target] = value;
    this.setState({
      article: article
    });
  }

  onContentChange(model) {
    let value = model;
    let article = this.state.article;
    article["body"] = value;
    this.setState({
      article: article
    });
  }

  handleCheckBoxChange(e) {
    const { value } = e.target;
    let article = this.state.article;
    let category_ids = [];
    category_ids.push(value);
    this.setState({
      article: {
        ...article,
        category_ids
      }
    });
  }

  onSelectFile = e => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        this.setState({ src: reader.result })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
    this.setState({
      editable: true
    });
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = image => {
    this.imageRef = image;
  };

  onCropComplete = crop => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "newFile.jpeg"
      );
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    //图片缩放
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    /**
    
     * 画布大小
     */
    // 图片原始尺寸
    var originWidth = crop.width * scaleX;
    var originHeight = crop.height * scaleY;
    // 最大尺寸限制
    var maxWidth = 1200,
      maxHeight = 1200 / (16 / 9);
    // 目标尺寸
    var targetWidth = originWidth,
      targetHeight = originHeight;
    // 图片尺寸超过1200x1200的限制
    if (originWidth > maxWidth || originHeight > maxHeight) {
      if (originWidth / originHeight > maxWidth / maxHeight) {
        // 更宽，按照宽度限定尺寸
        targetWidth = maxWidth;
        targetHeight = Math.round(maxWidth * (originHeight / originWidth));
      } else {
        targetHeight = maxHeight;
        targetWidth = Math.round(maxHeight * (originWidth / originHeight));
      }
    }
    // canvas对图片进行缩放
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image, //原始图片
      crop.x * scaleX, //x-axis coordinate of  top left corner of source image
      crop.y * scaleY, //y-axis coordinate of top left corner of source image
      crop.width * scaleX, //the width of the sub-rectangle of the source image
      crop.height * scaleY, //the height of the sub-rectangle of the source image
      0, //x-axis coordinate in the destination canvas at which to place the top-left corner of the source image.
      0, //y-axis coordinate in the destination canvas at which to place the top-left corner of the source image.
      targetWidth, //The width to draw the image in the destination canvas. This allows scaling of the drawn image.
      targetHeight //The height to draw the image in the destination canvas. This allows scaling of the drawn image.
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        blob => {
          if (!blob) {
            console.error("Canvas is empty");
            return;
          }
          blob.name = fileName;
          this.setState({
            file: blob
          });
          window.URL.revokeObjectURL(this.fileUrl);
          this.fileUrl = window.URL.createObjectURL(blob);
          resolve(this.fileUrl);
        },
        "image/png",
        1
      );
    });
  }

  confirmImg() {
    this.setState({
      editable: false
    });
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  toggleModal() {
    if (!this.state.paymentModal) {
      let vacancy_weeks = this.state.article.vacancy_weeks;
      let category_id = this.state.article.category_ids[0];
      this.props.quoteArticle({ vacancy_weeks, category_id });
    }

    this.setState({
      paymentModal: !this.state.paymentModal
    });
  }

  submitArticle() {
    let { file, article } = this.state;
    const category_id = article.category_ids[0];
    const title = article.title;
    const body = article.body;
    const status = "published";
    const weeks = article.vacancy_weeks;
    const type = article.type;
    const note = article.note;
    const cover_image = file;
    const path = "admin";
    this.props.createArticle({
      category_id,
      title,
      body,
      cover_image,
      weeks,
      type,
      status,
      note,
      path
    });
  }

  render() {
    const { crop, croppedImageUrl, src, editable } = this.state;
    const {
      getArticleRequest,
      errors,
      editArticleRequest,
      errorMsg,
      successBackMsg
    } = this.props.catadvs;
    const coverImg = croppedImageUrl
      ? croppedImageUrl
      : DOMAIN + "resources/cloud-upload-light.png";
    var sectionStyle = {
      width: "100%",
      paddingBottom: "60%",
      height: "0",
      border: "1px solid #ccc",
      borderRadius: "4px",
      background:
        'url("' +
        coverImg +
        '") center center / cover no-repeat rgb(255, 255, 255)'
    };
    var fileInputStyle = {
      position: "absolute",
      opacity: 0,
      right: 0,
      top: 0,
      bottom: 0,
      left: 0,
      filter: "alpha(opacity = 0)",
      cursor: "pointer"
    };
    var uploadBtnWrapper = {
      position: "relative",
      display: "block",
      borderRadius: "6px",
      cursor: "pointer"
    };

    return (
      <>
        <Container className="mt-4" fluid>
          <Card className="card-frame">
            <CardHeader className="border-0">
              <div className="d-flex align-items-center justify-content-between">
                <div>發付費廣告</div>
                <div className="d-flex align-items-center">
                  <Button color="secondary" type="button">
                    返回
                  </Button>
                </div>
              </div>
            </CardHeader>
            <OverlayLoading loading={getArticleRequest}>
              <CardBody className="row">
                <div className="col-lg-8 px-4">
                  <TextEditor
                    content={this.state.article ? this.state.article.body : ""}
                    onContentChange={this.onContentChange}
                  />
                </div>
                <div className="col-lg-4 px-4">
                  {errorMsg && (
                    <UncontrolledAlert color="danger" fade={false}>
                      <span className="alert-inner--text mb-4">{errorMsg}</span>
                    </UncontrolledAlert>
                  )}
                  {successBackMsg && (
                    <UncontrolledAlert color="success" fade={false}>
                      <span className="alert-inner--text mb-4">
                        {successBackMsg}
                      </span>
                    </UncontrolledAlert>
                  )}
                  <ArticleForm
                    data={this.state.article}
                    onTextInputChange={this.onTextInputChange}
                    handleCheckBoxChange={this.handleCheckBoxChange}
                    submitArticle={this.submitArticle}
                    loading={editArticleRequest}
                  />
                  <FormGroup>
                    <label
                      className="form-control-label"
                      htmlFor="example-date-input"
                    >
                      封面圖片
                    </label>
                    {src && editable && (
                      <ReactCrop
                        src={src}
                        crop={crop}
                        onImageLoaded={this.onImageLoaded}
                        onComplete={this.onCropComplete}
                        onChange={this.onCropChange}
                      />
                    )}
                    {!editable && <div style={sectionStyle}></div>}
                    <div className="d-flex flex-row">
                      {editable && (
                        <button
                          type="button"
                          className="mt-2 btn btn-default"
                          onClick={this.confirmImg}
                        >
                          確認
                        </button>
                      )}
                      <div className="mt-2" style={uploadBtnWrapper}>
                        <button
                          type="button"
                          style={{ cursor: "pointer" }}
                          block={true}
                          className="btn btn-default"
                        >
                          上傳圖片
                        </button>
                        <input
                          style={fileInputStyle}
                          type="file"
                          onChange={this.onSelectFile}
                          accept="image/x-png,image/gif,image/jpeg"
                        />
                      </div>
                    </div>
                  </FormGroup>
                </div>
              </CardBody>
            </OverlayLoading>
          </Card>
        </Container>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    catadvs: state.catadvs,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createArticle: params => dispatch(createArticle(params))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AricleNewPage);
